import { render, staticRenderFns } from "./JdcCard.vue?vue&type=template&id=6668d557&scoped=true"
import script from "./JdcCard.vue?vue&type=script&lang=js"
export * from "./JdcCard.vue?vue&type=script&lang=js"
import style0 from "./JdcCard.vue?vue&type=style&index=0&id=6668d557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6668d557",
  null
  
)

export default component.exports